
import { useCallback } from "react";
import { GraphLink } from "./useGraphTypes";

export const useGraphFiltering = () => {
  const updateLinkOpacity = useCallback((
    links: GraphLink[],
    collectionLinkOpacity: number,
    tagLinkOpacity: number
  ): GraphLink[] => {
    return links.map(link => ({
      ...link,
      opacity: link.type === 'collection' ? collectionLinkOpacity / 100 : tagLinkOpacity / 100
    }));
  }, []);

  return {
    updateLinkOpacity
  };
};
